import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ContactFormDialogComponent } from './contact-form-dialog/contact-form-dialog.component';

@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.scss']
})

export class AddContactComponent implements OnInit {

  contactId: string;
  @Input() inputType: string;

  constructor(
    private dialog: MatDialog) {
  }

  ngOnInit() { }

  openDialog(): void {
    const dialogRef = this.dialog.open(ContactFormDialogComponent, {
      position: {
        right: '0',
      },
      panelClass: 'small_layout',
      hasBackdrop: false,
      data: { contactId: this.contactId },
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

}
